module.exports = __webpack_public_path__ + "img/Main_image.bdd1f9d.jpg";